(ns motorsaif.web.admin.table
  (:require
   [motorsaif.web.admin.users :as users]
   [motorsaif.web.admin.businesses :as businesses]
   [motorsaif.web.admin.requests :as requests]
   [motorsaif.web.components :as c]
   [motorsaif.web.components.tabular :as tabular]
   [motorsaif.frontend-routes :as routes]
   [re-frame.core :as rf :refer [subscribe]]))


(defn root []
  (let [{:keys [table]} @(subscribe [:route/parameters])]
    [:div
     [c/header-with-back
      "Admin Management"
      {:subtitle (name table)}]
     (condp = table
       :users [users/root]
       :businesses [businesses/root]
       :requests [requests/root]
       )]))
